export const ZIndices = {
    NAVIGATION_MENU: '1',
    NAVIGATION_MENU_DROPDOWN: '2',
    NEED_HELP_COMPONENT: '2',
    STEPS_BAR_CROSS_LINE: '1'
};
